document.addEventListener("DOMContentLoaded", () => {

    const banner = document.querySelector(".hgp-faith-container");

    if (!banner) return;

    const observer = new IntersectionObserver((entries) => {

        entries.forEach((entry) => {

            if (!entry.isIntersecting) return;

            banner.classList.add("show");

            observer.unobserve(banner);

        });

    }, {
        threshold: 0.2
    });

    observer.observe(banner);

});